import { SeekDisplay } from ".";
import Section from "./Section";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBible, faClock } from "@fortawesome/free-solid-svg-icons";
import { useRef } from "react";
import { useDimensions } from "../../hooks/useDimensions";
import { useSeekBar } from "../../contexts/SeekBar";
import { useMarkers } from "../../contexts/Markers";
import { useRoot } from "../../contexts/Root";
import { useClip } from "../../contexts/Clip";
import { videoTimeToString } from "../../utils/time";
import { useVideoSource } from "../../contexts/VideoSource";
import { Handler } from "../../types/handler";
import { calculatePositions } from "../../utils/clipDisplays";

const minimumGap = 10;

export const ClipDisplays = () => {
  const startRef = useRef(null);
  const endRef = useRef(null);

  const { duration } = useVideoSource();
  const { markers } = useMarkers();
  const {
    theme: { foreground, fadedForeground },
  } = useRoot();
  const {
    width: seekBarWidth,
    hoverHandler,
    activeHandler,
    isPointerInside,
  } = useSeekBar();
  const { rangeInPixels, rangeInTime, show: showClipRange } = useClip();

  const { width: startWidth } = useDimensions(showClipRange, startRef);
  const { width: endWidth } = useDimensions(showClipRange, endRef);

  const show =
    showClipRange &&
    (!isPointerInside ||
      activeHandler === Handler.startClip ||
      activeHandler === Handler.endClip ||
      hoverHandler === Handler.startClip ||
      hoverHandler === Handler.endClip);

  const [startOffset, endOffset] = calculatePositions(
    rangeInPixels?.start ?? 0,
    rangeInPixels?.end ?? seekBarWidth,
    startWidth,
    endWidth,
    seekBarWidth,
    minimumGap
  );

  const reversedMarkers = [...markers].reverse();

  const startMarker = reversedMarkers.find(
    (marker) => marker.time <= (rangeInTime?.start ?? 0)
  );

  const endMarker = reversedMarkers.find(
    (marker) => marker.time <= (rangeInTime?.end ?? duration)
  );

  const startTime = videoTimeToString({
    currentTime: rangeInTime?.start ?? 0,
    duration,
  }).currentTime;

  const endTime = videoTimeToString({
    currentTime: rangeInTime?.end ?? duration,
    duration,
  }).currentTime;

  return (
    <>
      <SeekDisplay
        ref={startRef}
        show={show}
        offset={startOffset}
        // expand={isOnMarker}
      >
        <Section
          color={foreground}
          text={startTime}
          icon={<FontAwesomeIcon icon={faClock} />}
        />
        {markers.length > 0 && (
          <Section
            color={fadedForeground}
            text={startMarker?.label ?? "??:??"}
            icon={<FontAwesomeIcon icon={faBible} />}
          />
        )}
      </SeekDisplay>
      <SeekDisplay
        ref={endRef}
        show={show}
        offset={endOffset}
        // expand={isOnMarker}
      >
        <Section
          color={foreground}
          text={endTime}
          icon={<FontAwesomeIcon icon={faClock} />}
        />
        {markers.length > 0 && (
          <Section
            color={fadedForeground}
            text={endMarker?.label ?? "??:??"}
            icon={<FontAwesomeIcon icon={faBible} />}
          />
        )}
      </SeekDisplay>
    </>
  );
};
